(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reframe-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var items = document.querySelectorAll('#faq-list .rf-faq__item');
    items.forEach(function(item) {
      var btn = item.querySelector('.rf-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var open = item.classList.contains('is-open');
        items.forEach(function(i) {
          i.classList.remove('is-open');
          var b = i.querySelector('.rf-faq__q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var countdown = document.querySelector('.rf-hero__countdown');
    if (!countdown) return;
    var raw = countdown.getAttribute('data-target-date');
    if (!raw) return;
    var target = new Date(raw).getTime();
    if (isNaN(target)) return;
    var els = {
      days: document.getElementById('cd-days'),
      hours: document.getElementById('cd-hours'),
      mins: document.getElementById('cd-mins'),
      secs: document.getElementById('cd-secs')
    };
    if (!els.days) return;
    function pad(n) { return String(Math.max(0,n)).padStart(2,'0'); }
    function tick() {
      var d = Math.max(0, target - Date.now());
      els.days.textContent  = pad(Math.floor(d / 86400000));
      els.hours.textContent = pad(Math.floor((d % 86400000) / 3600000));
      els.mins.textContent  = pad(Math.floor((d % 3600000) / 60000));
      els.secs.textContent  = pad(Math.floor((d % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-location"] && !Shopify.designMode) return;
  try {
    
  // ─── Location Slider ───────────────────────────────
  (function() {
    var slides   = document.querySelectorAll('#rf-location-slider .rf-location__slide');
    var prevBtn  = document.getElementById('rf-loc-prev');
    var nextBtn  = document.getElementById('rf-loc-next');
    var dotsWrap = document.getElementById('rf-loc-dots');
    var currEl   = document.getElementById('rf-loc-current');
    var totalEl  = document.getElementById('rf-loc-total');

    if (!slides.length) return;

    var current   = 0;
    var total     = slides.length;
    var autoTimer = null;

    if (totalEl) totalEl.textContent = total;

    // Dots aufbauen
    slides.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'rf-location__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Bild ' + (i + 1));
      dot.addEventListener('click', function() { goTo(i); resetAuto(); });
      dotsWrap.appendChild(dot);
    });

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      dotsWrap.children[current].classList.remove('is-active');
      current = (idx + total) % total;
      slides[current].classList.add('is-active');
      dotsWrap.children[current].classList.add('is-active');
      if (currEl) currEl.textContent = current + 1;
    }

    function resetAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(function() { goTo(current + 1); }, 5000);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); resetAuto(); });

    // Touch / Swipe
    var touchStartX = 0;
    var slider = document.getElementById('rf-location-slider');
    if (slider) {
      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      slider.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) { goTo(dx < 0 ? current + 1 : current - 1); resetAuto(); }
      }, { passive: true });
    }

    resetAuto();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-talks"] && !Shopify.designMode) return;
  try {
    
  // ─── Live Talks: Tagesfilter ───────────────────────
  (function() {
    var filterBtns = document.querySelectorAll('.rf-talks__filter-btn');
    var cards      = document.querySelectorAll('#rf-talks-grid .rf-talks__card');
    if (!filterBtns.length) return;

    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var filter = this.getAttribute('data-filter');

        // Aktiven Button setzen
        filterBtns.forEach(function(b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Karten ein-/ausblenden
        cards.forEach(function(card) {
          if (filter === 'all' || card.getAttribute('data-day') === filter) {
            card.classList.remove('rf-talks__card--hidden');
          } else {
            card.classList.add('rf-talks__card--hidden');
          }
        });
      });
    });
  })();

  // ─── Live Talks: Modal ─────────────────────────────
  (function() {
    var overlay    = document.getElementById('rf-talks-modal-overlay');
    var closeBtn   = document.getElementById('rf-talks-modal-close');
    var slidesWrap = document.getElementById('rf-talks-modal-slides');
    var sliderWrap = document.getElementById('rf-talks-modal-slider-wrap');
    var prevBtn    = document.getElementById('rf-talks-modal-prev');
    var nextBtn    = document.getElementById('rf-talks-modal-next');
    var currEl     = document.getElementById('rf-talks-modal-current');
    var totalEl    = document.getElementById('rf-talks-modal-total');
    var metaEl     = document.getElementById('rf-talks-modal-meta');
    var headingEl  = document.getElementById('rf-talks-modal-heading');
    var textEl     = document.getElementById('rf-talks-modal-text');
    if (!overlay) return;

    var current = 0;
    var images  = [];

    function pauseVideoInSlide(slide) {
      var iframe = slide && slide.querySelector('iframe');
      if (iframe) iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }

    function goTo(idx) {
      var slides = slidesWrap.querySelectorAll('.rf-talks__modal-slide');
      if (!slides.length) return;
      pauseVideoInSlide(slides[current]);
      slides[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (currEl) currEl.textContent = current + 1;
    }

    function openModal(card) {
      // Bilder laden
      images = [];
      try { images = JSON.parse(card.getAttribute('data-images') || '[]'); } catch(e) {}
      if (!images.length) {
        var thumb = card.querySelector('.rf-talks__card-img-wrap img');
        if (thumb) images = [thumb.src];
      }

      // Slides aufbauen
      slidesWrap.innerHTML = '';
      var videoId = card.getAttribute('data-video') || '';
      var totalSlides = 0;

      // Video-Slide zuerst (wenn vorhanden)
      if (videoId) {
        var videoSlide = document.createElement('div');
        videoSlide.className = 'rf-talks__modal-slide rf-talks__modal-slide--video is-active';
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&enablejsapi=1&playsinline=1';
        iframe.title = 'Talk Video';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        videoSlide.appendChild(iframe);
        slidesWrap.appendChild(videoSlide);
        totalSlides++;
      }

      // Bild-Slides
      images.forEach(function(url) {
        var slide = document.createElement('div');
        slide.className = 'rf-talks__modal-slide' + (totalSlides === 0 ? ' is-active' : '');
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        slide.appendChild(img);
        slidesWrap.appendChild(slide);
        totalSlides++;
      });

      current = 0;
      if (totalEl) totalEl.textContent = totalSlides;
      if (currEl)  currEl.textContent  = 1;

      // Pfeile & Counter ausblenden wenn nur ein Slide
      if (totalSlides <= 1) {
        sliderWrap.classList.add('is-single');
      } else {
        sliderWrap.classList.remove('is-single');
      }

      // Meta (Tag + Uhrzeit als Badges)
      var dayLabel  = card.getAttribute('data-day-label') || '';
      var timeLabel = card.getAttribute('data-time') || '';
      metaEl.innerHTML =
        (dayLabel  ? '<span class="rf-talks__badge-day">'  + dayLabel  + '</span>' : '') +
        (timeLabel ? '<span class="rf-talks__badge-time">' + timeLabel + '</span>' : '');

      // Titel
      headingEl.textContent = card.getAttribute('data-title') || '';

      // Volltext
      var fulltextEl = card.querySelector('.rf-talks__fulltext');
      textEl.innerHTML = fulltextEl ? fulltextEl.innerHTML : '';

      // Overlay öffnen
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      slidesWrap.innerHTML = '';
      current = 0;
    }

    // Karten-Klick
    document.querySelectorAll('#rf-talks-grid .rf-talks__card').forEach(function(card) {
      card.addEventListener('click', function() { openModal(this); });
    });

    // Schließen
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Slider-Pfeile
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Touch/Swipe im Modal
    var touchStartX = 0;
    if (slidesWrap) {
      slidesWrap.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      slidesWrap.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-tickets"] && !Shopify.designMode) return;
  try {
    
  // ─── Ticket-Picker: Variante & Preis synchronisieren ──────
  (function() {
    var radios    = document.querySelectorAll('input[name="rf_variant_choice"]');
    var variantId = document.getElementById('rf-variant-id');
    var priceEl   = document.getElementById('rf-price-display');

    if (!radios.length) return;

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (!this.checked) return;
        var label = this.closest('.rf-ticket-option');
        if (variantId) variantId.value = this.value;
        if (priceEl && label) priceEl.textContent = label.getAttribute('data-price');
      });
    });
  })();

  // ─── Mengensteuerung ───────────────────────────────
  (function() {
    var qtyInput = document.getElementById('rf-qty');
    if (!qtyInput) return;

    var minusBtn = document.querySelector('.rf-qty-minus');
    var plusBtn  = document.querySelector('.rf-qty-plus');

    if (minusBtn) minusBtn.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    if (plusBtn) plusBtn.addEventListener('click', function() {
      var v   = parseInt(qtyInput.value, 10);
      var max = parseInt(qtyInput.max, 10) || 10;
      if (v < max) qtyInput.value = v + 1;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-workshops"] && !Shopify.designMode) return;
  try {
    
  // ─── Workshops: Tagesfilter ────────────────────────────
  (function() {
    var filterBtns = document.querySelectorAll('.rf-workshops__filter-btn');
    var cards      = document.querySelectorAll('#rf-workshops-grid .rf-workshops__card');
    if (!filterBtns.length) return;

    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var filter = this.getAttribute('data-filter');
        filterBtns.forEach(function(b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        cards.forEach(function(card) {
          if (filter === 'all' || card.getAttribute('data-day') === filter) {
            card.classList.remove('rf-workshops__card--hidden');
          } else {
            card.classList.add('rf-workshops__card--hidden');
          }
        });
      });
    });
  })();

  // ─── Workshops: Karte klickbar → Produktseite ─────────
  (function() {
    document.querySelectorAll('#rf-workshops-grid .rf-workshops__card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (!e.target.closest('a, button')) {
          var url = card.getAttribute('data-product-url');
          if (url) window.location.href = url;
        }
      });
    });
  })();

  // ─── Workshops: Modal & Add-to-Cart ───────────────────
  (function() {
    var overlay    = document.getElementById('rf-workshops-modal-overlay');
    var closeBtn   = document.getElementById('rf-workshops-modal-close');
    var slidesWrap = document.getElementById('rf-workshops-modal-slides');
    var sliderWrap = document.getElementById('rf-workshops-modal-slider-wrap');
    var prevBtn    = document.getElementById('rf-workshops-modal-prev');
    var nextBtn    = document.getElementById('rf-workshops-modal-next');
    var currEl     = document.getElementById('rf-workshops-modal-current');
    var totalEl    = document.getElementById('rf-workshops-modal-total');
    var metaEl     = document.getElementById('rf-workshops-modal-meta');
    var headingEl  = document.getElementById('rf-workshops-modal-heading');
    var textEl     = document.getElementById('rf-workshops-modal-text');
    var cartBtn    = document.getElementById('rf-workshops-modal-cart-btn');
    if (!overlay) return;

    var current   = 0;
    var variantId = '';

    function goTo(idx) {
      var slides = slidesWrap.querySelectorAll('.rf-workshops__modal-slide');
      if (!slides.length) return;
      slides[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (currEl) currEl.textContent = current + 1;
    }

    function openModal(card) {
      var images = [];
      try { images = JSON.parse(card.getAttribute('data-images') || '[]'); } catch(e) {}
      if (!images.length) {
        var thumb = card.querySelector('.rf-workshops__card-img-wrap img');
        if (thumb && thumb.src) images = [thumb.src];
      }

      slidesWrap.innerHTML = '';
      var totalSlides = 0;
      images.forEach(function(url) {
        var slide = document.createElement('div');
        slide.className = 'rf-workshops__modal-slide' + (totalSlides === 0 ? ' is-active' : '');
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        slide.appendChild(img);
        slidesWrap.appendChild(slide);
        totalSlides++;
      });

      if (totalSlides === 0) {
        var placeholder = document.createElement('div');
        placeholder.className = 'rf-workshops__modal-slide is-active';
        placeholder.style.cssText = 'background:var(--rf-gray-mid);display:flex;align-items:center;justify-content:center;';
        slidesWrap.appendChild(placeholder);
        totalSlides = 1;
      }

      current = 0;
      if (totalEl) totalEl.textContent = totalSlides;
      if (currEl)  currEl.textContent  = 1;
      if (totalSlides <= 1) {
        sliderWrap.classList.add('is-single');
      } else {
        sliderWrap.classList.remove('is-single');
      }

      var dayLabel      = card.getAttribute('data-day-label') || '';
      var timeLabel     = card.getAttribute('data-time') || '';
      var durationLabel = card.getAttribute('data-duration') || '';
      var instructor    = card.getAttribute('data-instructor') || '';
      var price         = card.getAttribute('data-price') || '';
      variantId         = card.getAttribute('data-variant-id') || '';

      metaEl.innerHTML =
        (dayLabel      ? '<span class="rf-workshops__modal-badge rf-workshops__modal-badge--day">' + dayLabel + '</span>' : '') +
        (timeLabel     ? '<span class="rf-workshops__modal-badge">' + timeLabel + '</span>' : '') +
        (durationLabel ? '<span class="rf-workshops__modal-badge">' + durationLabel + '</span>' : '') +
        (instructor    ? '<span class="rf-workshops__modal-badge">' + instructor + '</span>' : '');

      headingEl.textContent = card.getAttribute('data-title') || '';

      var fulltextEl = card.querySelector('.rf-workshops__fulltext');
      textEl.innerHTML = fulltextEl ? fulltextEl.innerHTML : '';

      if (cartBtn) {
        cartBtn.textContent = price ? 'In den Warenkorb \u2014 \u20ac\u00a0' + price : 'In den Warenkorb';
        cartBtn.disabled = false;
      }

      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Schließen
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Slider-Pfeile
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Touch/Swipe im Modal
    var touchStartX = 0;
    if (slidesWrap) {
      slidesWrap.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      slidesWrap.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    // Add-to-Cart
    if (cartBtn) {
      cartBtn.addEventListener('click', function() {
        if (!variantId) return;
        var btn = this;
        var originalText = btn.textContent;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('cart error');
          btn.textContent = '\u2713 Im Warenkorb';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2500);
        })
        .catch(function() {
          btn.textContent = 'Fehler \u2014 bitte erneut versuchen';
          btn.disabled = false;
          setTimeout(function() { btn.textContent = originalText; }, 3000);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
